module.exports = __webpack_public_path__ + "img/ic-Photo.8a6f8212.svg";